import { z } from 'zod'

export const customerTrackListOptionsSchema = z.object({
  venueId: z.union([z.string(), z.array(z.string())]).optional(),
  skip: z.number().optional(),
  limit: z.number().optional(),
  sort: z.string().optional(),
})

export const customerTrackListByCustomerAndSessionArgsSchema = z.object({
  customerId: z.string(),
  sessionId: z.string(),
  options: customerTrackListOptionsSchema.optional(),
})
